<template>
    <div>
        <v-navigation-drawer
                fixed
                app
                :clipped="$vuetify.breakpoint.mdAndUp"
                :fixed="true"
                :value="drawer"
                @input="$emit('toggleDrawer', $event)"
        >
            <v-list dense>
                <v-container fluid>
                    <department-subject-switcher 
                            :is-open="isDepartmentSubjectSwitcherOpened"
                            :is-show-button="isDepSubjNavigation()"
                            @changeDialogState="isDepartmentSubjectSwitcherOpened = $event"
                            route-back="reworksHome"
                            :route-to="switcherDialogRoute"
                    />
                </v-container>

                <v-subheader class="mt-1 grey--name name--darken-1">Електронний журнал</v-subheader>
                <navigation-list-template :items="dictionaryItems" @selectValue="setTopNavigationItem($event)"/>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
    import NavigationListTemplate from "../../common/NavigationListTemplate";
    import DepartmentSubjectSwitcher from "../../common/DepartmentSubjectSwitcher";
    import {mapMutations} from "vuex";

    export default {
        props: {
            drawer: {
                type: Boolean,
            }
        },
        data: () => ({
            switcherDialogRoute: "",
            isDepartmentSubjectSwitcherOpened: false,
            dictionaryItems: [],
            dictionaryItemsRaw: [
                {
                    icon: 'turned_in',
                    name: 'Відпрацювання поточних оцінок',
                    route: {
                        name: 'reworkMarksRoot'
                    }
                },
                {
                    icon: 'view_module',
                    name: 'Відпрацювання ПМК',
                    route: {
                        name: 'reworkModulesRoot'
                    }
                },
                {
                    divider: true
                },
            ],
        }),
        components: {
            NavigationListTemplate,
            DepartmentSubjectSwitcher
        },
        mounted() {
            this.dictionaryItems = this.remapItems(this.dictionaryItemsRaw);

            this.dialogNavigationDepartmentSubject();
        },
        watch: {
            $route (to, from){
                this.dialogNavigationDepartmentSubject();
            }  
        },
        methods: {
            ...mapMutations(['setTopNavigationItem']),
            dialogNavigationDepartmentSubject() {
                const routeName = this.$route.name;
                if (!this.isDepSubjNavigation() && 
                    (routeName === 'reworkMarksRoot' || routeName === 'reworkModulesRoot')
                ) {
                    this.isDepartmentSubjectSwitcherOpened = true;
                    
                    this.switcherDialogRoute = routeName;
                }
            },
            remapItems(items) {
                let itemsRemapped = items.slice(0);

                return itemsRemapped.map(item => {
                    if (item.children !== undefined) {
                        item.children = item.children.map(ch => {
                            if (ch.route && ch.route.name && this.$route.name === ch.route.name) {
                                ch.model = true;
                                this.setTopNavigationItem(ch);
                            }
                            return ch;
                        });

                        let someActiveChildren = item.children.find(ch => ch.model);

                        if (someActiveChildren !== undefined) {
                            item.model = true;
                        }

                        return item;
                    }

                    if (item.route && item.route.name && this.$route.name === item.route.name) {
                        this.setTopNavigationItem(item);
                    }

                    return item;
                })
            },
            isDepSubjNavigation() {
                return (this.$route.params.department !== undefined && 
                        this.$route.params.subject !== undefined);
            }
        },
    }
</script>